import i18n from 'i18n';
import { dateFilterParams } from '../../../shared/constants/index';

export default [
  {
    headerName: i18n.t('wiretap.grid.wiretapState'),
    field: 'status',
    sortable: true,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'status',
    filterParams: {
      values: [
        'UNKNOWN',
        'SCHEDULED',
        'TOBEPROV',
        'PROVISIONED',
        'PROVFAIL',
        'TOBEDEL',
        'DELETED',
        'DELFAIL',
        'TARGETNOTFOUND',
        'INACTIVE',
      ],
    },
  },
  {
    headerName: i18n.t('wiretap.grid.accessFunction'),
    field: 'afId.name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'afId.name',
  },
  {
    headerName: i18n.t('wiretap.grid.aFID'),
    field: 'afId.afId',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'AFID',
    hide: true,
  },
  {
    headerName: i18n.t('wiretap.grid.accessFunctionGroup'),
    field: 'afGroupId.name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'afGroupId.name',
  },
  {
    headerName: i18n.t('wiretap.grid.caseId'),
    field: 'caseId.name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'caseId.name',
  },
  {
    headerName: i18n.t('wiretap.grid.coId'),
    field: 'caseId.coId',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'COID',
    hide: true,
  },
  {
    headerName: i18n.t('wiretap.grid.caseState'),
    field: 'reporting.caseStatus',
    sortable: true,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'reporting.caseStatus',
    filterParams: {
      values: ['ACTIVE', 'INACTIVE'],
    },
  },
  {
    headerName: i18n.t('wiretap.grid.collectionFunction'),
    field: 'reporting.cfid.name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'reporting.cfid.name',
  },
  {
    headerName: i18n.t('wiretap.grid.cfId'),
    field: 'reporting.cfid.cfId',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'CFID',
    hide: true,
  },
  {
    headerName: i18n.t('wiretap.grid.comments'),
    field: 'comments',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'comments',
  },
  {
    headerName: i18n.t('wiretap.grid.contact'),
    field: 'reporting.contact.name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'reporting.contact.name',
  },
  {
    headerName: i18n.t('wiretap.grid.deprovisionTime'),
    field: 'deprovisionDateTime',
    sortable: true,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'deprovisionDateTime',
    filterParams: dateFilterParams,
    cellRenderer: 'DateTimeWithTimezoneCellRenderer',
    cellRendererParams: { timezoneField: 'reporting.timeZone' },
  },
  {
    headerName: i18n.t('wiretap.grid.entryTime'),
    field: 'reporting.entryDateTime',
    sortable: true,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'reporting.entryDateTime',
    filterParams: dateFilterParams,
    cellRenderer: 'DateTimeWithTimezoneCellRenderer',
    cellRendererParams: { timezoneField: 'reporting.timeZone' },
  },
  {
    headerName: i18n.t('wiretap.grid.errorMessage'),
    field: 'errorMessage',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'errorMessage',
  },
  {
    headerName: i18n.t('wiretap.grid.provisionTime'),
    field: 'provisionDateTime',
    sortable: true,
    filter: 'agDateColumnFilter',
    filterParams: dateFilterParams,
    floatingFilter: true,
    resizable: true,
    tooltipField: 'provisionDateTime',
    cellRenderer: 'DateTimeWithTimezoneCellRenderer',
    cellRendererParams: { timezoneField: 'reporting.timeZone' },
  },
  {
    headerName: i18n.t('wiretap.grid.receivedTime'),
    field: 'reporting.receivedDateTime',
    sortable: true,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'reporting.receivedDateTime',
    filterParams: dateFilterParams,
    cellRenderer: 'DateTimeWithTimezoneCellRenderer',
    cellRendererParams: { timezoneField: 'reporting.timeZone' },
  },
  {
    headerName: i18n.t('wiretap.grid.secondaryTargetType'),
    field: 'reporting.secondaryType',
    sortable: true,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'reporting.secondaryType',
    filterParams: {
      values: [
        'CASEID',
        'IMSI',
        'LOGIN',
        'MDN',
        'MIN',
        'MSISDN',
        'SIP-URI',
        'TEL-URI',
      ],
    },
  },
  {
    headerName: i18n.t('wiretap.grid.secondaryTargetValue'),
    field: 'reporting.secondaryValue',
    sortable: false,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'reporting.secondaryValue',
    filterParams: {
      filterOptions: ['equals', 'notEqual'],
    },
  },
  {
    headerName: i18n.t('wiretap.grid.startTime'),
    field: 'reporting.startDateTime',
    sortable: true,
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'reporting.startDateTime',
    filterParams: dateFilterParams,
    cellRenderer: 'DateTimeWithTimezoneCellRenderer',
    cellRendererParams: { timezoneField: 'reporting.timeZone' },
  },
  {
    headerName: i18n.t('wiretap.grid.stopTime'),
    field: 'reporting.stopDateTime',
    sortable: true,
    resizable: true,
    tooltipField: 'reporting.stopDateTime',
    filter: 'agDateColumnFilter',
    floatingFilter: true,
    filterParams: dateFilterParams,
    cellRenderer: 'DateTimeWithTimezoneCellRenderer',
    cellRendererParams: { timezoneField: 'reporting.timeZone' },
  },
  {
    headerName: i18n.t('wiretap.grid.timeZone'),
    field: 'reporting.timeZone',
    sortable: false,
    resizable: true,
    floatingFilter: true,
    tooltipField: 'reporting.timeZone',
    cellRenderer: 'TimeZoneCellRenderer',
  },
  /*
  NOTE: Those columns are hidden because different teams can't have access to the wiretaps target types and value
  TODO: Xcipio's backend will not list all wiretaps to all users, it will list just to the wiretaps team members. So,
  as soon as xcipio has implemented that, those columns must be shown again.
  05 Jun 2025: Uncomment this field since its required by Tunisia */
  {
    headerName: i18n.t('wiretap.grid.targetType'),
    field: 'reporting.primaryType',
    sortable: true,
    filter: 'agSetColumnFilter',
    floatingFilter: true,
    resizable: true,
    hide: true,
    tooltipField: 'reporting.primaryType',
    filterParams: {
      values: [
        'CASEID',
        'IMSI',
        'LOGIN',
        'MDN',
        'MIN',
        'MSISDN',
        'SIP-URI',
        'TEL-URI',
      ],
    },
  },
  {
    headerName: i18n.t('wiretap.grid.targetValue'),
    field: 'reporting.primaryValue',
    sortable: false,
    resizable: true,
    hide: true,
    tooltipField: 'reporting.primaryValue',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    filterParams: {
      filterOptions: ['equals', 'notEqual'],
    },
  },
  {
    headerName: i18n.t('wiretap.grid.warrantName'),
    field: 'reporting.warrantId.name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'reporting.warrantId.name',
  },
];
